import { getUuid, Uuid } from '@sibe/utilities/common';
import type { HsCamera } from '../objects/cameras/camera.class';

export class HsLayer {
  public readonly uuid: Uuid = getUuid();
  public readonly tags: Set<String> = new Set<String>();
  public order: number = 0;

  constructor(public camera: HsCamera) {}
}
